import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { FetchWidgetsAPI } from 'Services';
import { IAPI_ACTION, IDispatcherType, INITIAL_STATE } from 'types';
import Toasty from 'components/atoms/Toasty';

export const setAPIError = (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION): void => {
	state.loading = false;
	state.error = action.error.message || 'Something went wrong';
	Toasty.error(state.error);
};

export const fetchSwipeWidgets = createAsyncThunk('get/widgetsSwipe', FetchWidgetsAPI);

export const FetchSwipeWidgetsSlice = createSlice({
	name: 'fetchSwipeWidgets',
	initialState: INITIAL_STATE(),
	reducers: {
		CLEAR_ERROR: (state) => {
			state.error = '';
		},
		RESET: (state) => Object.assign(state, INITIAL_STATE()),
	},
	extraReducers: {
		[fetchSwipeWidgets.pending.toString()]: (state: ReturnType<typeof INITIAL_STATE>) => {
			state.data = {};
			state.error = '';
			state.loading = true;
			state.isFetched = false;
		},
		[fetchSwipeWidgets.rejected.toString()]: setAPIError,
		[fetchSwipeWidgets.fulfilled.toString()]: (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION<any>) => {
			const { payload } = action;

			state.loading = false;
			state.isFetched = true;
			state.error = '';
			state.data = payload;
		},
	},
});

interface IStates {
	[FetchSwipeWidgetsSlice.name]: ReturnType<typeof FetchSwipeWidgetsSlice.reducer>;
}

export const fetchWidgetsSwipeSelector = (state: IStates): any => {
	return state[FetchSwipeWidgetsSlice.name] || {};
};

export const useSwipeWidgets = (): any => useSelector(fetchWidgetsSwipeSelector);

export const getSwipeWidgets =
	(params: any) =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(fetchSwipeWidgets(params));
		return;
	};

export const resetSwipeWidgets =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(FetchSwipeWidgetsSlice.actions.RESET());
		return;
	};
